// l10n status: done
import { Link, Typography } from "@mui/material"
import React, { useLayoutEffect } from "react"

// import { relatedMovies } from "./../../../data/RelatedMovies"
import { CreateComponent } from "components/utils/CreateComponent"
import { rootStore } from "store/RootStore"
//import seriesLogo from "img/series-folder.svg"
import serieLogo from "img/icons/series.svg"
import { logResourceLoadFailure } from "utils/BugsnagReporter"
import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import Play from "img/player/play.svg"
// import PlayHover from "img/player/play-hover.svg"
//import { EventComponent } from "../../Overlay/components/EventComponent"

import "./slideRelatedContent.css"
//import { Img } from "components/Img"
import { computed } from "mobx"
import { eventId } from "utils/EventHelpers"
import { l10n } from "store/lang/L10n"
import { GenreTile } from "scenes/Discover/GenreTile"

const styles = theme => ({
	relatedMoviesGridList: {
		// width: "100%",
		// display: "flex",
		// flexFlow: "row wrap"
		display: "grid",
		//MTV-3492 css mobile first look relatedMoviesGridListResponsive
		gridTemplateColumns: "repeat(auto-fill, minmax(50%, 1fr))",
		gridGap: "24px",
	},
})


/** MTV-2808
 * if the player plays in overlay (from tvGuide and not tvLive)
 * the overlay must be reset if you change the event
 * * @ resetOverlay is the function that resets the state of OverlayEventDetails
 * This parameter is not used by TvLive
 
 **/

export const EpgChannelRelatedContent = CreateComponent(styles, false, true, ({ classes, oEventData, page, callingContext = CALLING_CONTEXT_TYPE.keepOldContext, origin, resetOverlay = () => { } }) => {
	//use to open new overlayDetails
	const pageOverlay = rootStore.page.OverlayEventDetails
	//MTVW-1075: related content from CoCo
	const relatedContent = oEventData?.recommendations?.length > 0 ? oEventData?.recommendations : [] //page.relatedContent

	useLayoutEffect(() => {
		if (eventId(oEventData)) {
			//console.debug("loading related content id %s", oEventData.id)
			// replaced with recommendations from CoCo
			//if (!(oEventData?.recommendations?.length > 0)) page.loadRelatedContent(oEventData)
			rootStore.page.CoCoBookmarks.getBookmarksAsync(true)
		}
	}, [oEventData, page])

	// MTV-3737 if there are related content then show with animation
	// MTV-3842 count only valid related content
	let countRelatedContent = 0
	// eslint-disable-next-line array-callback-return
	relatedContent?.map((item) => {
		//console.debug("item", item, item.data)
		if (item.data || oEventData?.recommendations?.length > 0) {
			countRelatedContent++
		}
	})
	//console.debug("relatedContent length", relatedContent.length, oEventData, oEventData?.recommendations)

	// MTV-3842 check whether there are 3 or 6 related contents (1 or 2 lines)
	// const classRelatedContentAnimation = relatedContent.length > 0
	const classRelatedContentAnimation = countRelatedContent > 0 ?
		countRelatedContent <= 3 ? "slideRelatedContent slideRelatedContentHalf" : "slideRelatedContent slideRelatedContentFull"
		: ""

	// GT12: MTVW-460, MTVW-502: Channels MS flags
	// seriesId: relatedTitle?.SeriesCollection?.Series[0]?.id
	const showPlayButton = (item) => {
		let isReplayAllowed = computed(() => rootStore.page.MsEpg?.isReplayAllowed(page.channelId(item), page.startTs(item), page.endTs(item))).get()
		// MTVW-629: commented 2nd parameter, recheck if needed
		if (rootStore.page.Recordings.Manager.getMarker(page.id(item)/*, relatedTitle?.SeriesCollection?.Series[0]?.id*/)?.isComplete) isReplayAllowed = true
		//console.debug("isReplayAllowed", isReplayAllowed, page.channelId(item), page.startTs(item), page.endTs(item))
		/*
		return (
			(page.eventType(item) !== "n") ?
				((((page.eventType(item)) &&
					// GT12
					//((((relatedItem.getCurrentEventType === "p") && !relatedItem.Channels.Channel[0].IsOnRecordingOptinList)
					!isReplayAllowed)
					? false
					: true))
				: false)
		*/
		return page.eventType(item) && page.eventType(item) !== "n" && isReplayAllowed
	}

	// MTV-3583: React 17 requires a value to be returned
	//console.debug("page.isReady", page.isReady, countRelatedContent, classRelatedContentAnimation)
	const MAX_RELATED_CONTENTS = 12
	return !(relatedContent?.length > 0) ? null : (
		<div className={`${classRelatedContentAnimation}`}>
			<div>
				{relatedContent?.length > 0 ?
					<Typography variant="h6" className="relatedMoviesHeader">
						<Link underline="hover">{l10n.featureDetailsRecommendations.toUpperCase()}</Link>
					</Typography>
					:
					null}
			</div>
			<div className={classes.relatedMoviesGridList + " relatedMoviesGridListResponsive"} >
				{relatedContent?.map((item, index) => {
					if (index > MAX_RELATED_CONTENTS - 1) return null
					const relatedItem = item.data
					const relatedTitle = page.title(item)
					const nbEpisodes = page.episodeCount(item)
					const relatedEpisodes = nbEpisodes > 1 ? l10n.featureRecordingsNumberOfEpisodes.format(nbEpisodes) : l10n.featureRecordingsNumberSingleEpisode.format(nbEpisodes)
					//if (page.episodeName(item)) console.warn("episode", page.episodeName(item))

					let relatedDetails = ""
					if (page.episodeName(item)) {
						let episode = page.episode(item) || ""
						let season = page.season(item) || ""
						episode = episode === "" ? "" : `E:${episode}`
						season = season === "" ? "" : `S:${season}`
						relatedDetails = `${season} ${episode} ${page.episodeName(item)} `
					}
					//console.debug("item is", item.type, item, index, page.id(item), page.title(item), page.eventType(item))

					// MTVW-931: replace EpisodeAndRelatedTile with GenreTile
					/*
					return (
						<EpisodeAndRelatedTile key={"reT_" + index} variant={"related"} page={page} oEventData={oEventData} item={item} ix={index} origin={origin} callingContext={callingContext} resetOverlay={resetOverlay} />
					)
					*/
					return (
						<GenreTile key={"re_T" + index} variant={"related"} page={page} oEventData={oEventData} item={item} ix={index} origin={origin} callingContext={callingContext} resetOverlay={resetOverlay} />
					)
				})
				}
			</div>
		</div>
	)
})
